import moment from "moment";
import { Link, Button, Span, Div, UnorderedList, ListItem } from "@tblabs/truffle";
import { DeliveryFormValueToLabel } from "../../Models/Basket/DeliveryForm";
import { ReturnFormValueToLabel } from "../../Models/Basket/ReturnForm";
import { Center } from "../Utils/Center";
import { CostsSummaryTable } from "./CostsSummaryTable";
import { DispatchTimeCalculator } from "../../Services/DispatchTimeCalculator";
import { Table } from "@tblabs/truffle/Controls/TableBuilder/Table";
import { Heading } from "../Heading";
import { BasketPaymentValueToLabel } from "../../Models/OrderTicket/PaymentForm";
import { Page } from "../../Pages/Product/Page";
import { BasketProvider } from "../../Services/BasketProvider";
import { PageFooter } from "../../Pages/Main/PageFooter";
import { ShopContentProvider } from "../../Services/Content/ShopContentProvider";
import { InfoBox } from "../../Pages/Product/InfoBox";
import { PrimaryButton } from "./PrimaryButton";
import { BasketSendingBox } from "./BasketSendingBox";


export class OrderSummaryPage extends Page
{
    constructor(_basket: BasketProvider, _shop: ShopContentProvider)
    {
        super("Podsumowanie zamówienia");
        this.Class("summary-box")

        this.Content(async (body) =>
        {
            const basket = _basket.Basket;
            const brain = _basket.BasketBrain;

            const returnToEditBtn = new Button("Wróć do edycji")
                .OnClick(() => window.location.hash = "koszyk");

            body.Append(
                new Heading("Podsumowanie zamówienia", 1).MarginTopBottom(16).Bold().FontSize(22)
            )

            if (basket.IsEmpty)
            {
                body.Append(
                    new Center(
                        new InfoBox("Koszyk jest pusty", "Nie ma żadnych produktów w koszyku.\nDodaj produkty, aby kontynuować."),
                        new PrimaryButton("Wróć do strony głównej", () => window.location.hash = "/")
                    ),
                )
                return;
            }

            body.Append(
                new Table([], [
                    ["Zamówienie", 
                        new UnorderedList(basket.Items.Items.map((item, index) =>item.Product?.BasketName.value + " (" + item.Quantity.value + " szt.)")).Style("list-style: disc; padding-left: 16px;"),
                    ]
                ]),
                new CostsSummaryTable(brain),
            )

            if (basket.IsAnythingToRent.value)
            {
                const deliveryTime = brain.IsPackageDelivery
                    ? DispatchTimeCalculator.Calc(basket.RentTime?.Start?.value)
                    : basket.RentTime?.Start.value;

                const deliveryTimeAsString = moment(deliveryTime).format("dddd DD.MM.YYYY");

                body.Append(
                    new Table([], [
                        ["Odbiór", `${DeliveryFormValueToLabel[brain.DeliveryForm.value]}, wstępnie ${deliveryTimeAsString}. Data została obliczona automatycznie i może ulec zmianie po akceptacji zamówienia`],
                        ["Zwrot", `${ReturnFormValueToLabel[brain.ReturnForm.value]}, wstępnie ${moment(basket.RentTime?.End?.value).format("dddd DD.MM.YYYY")}. Data została obliczona automatycznie i może ulec zmianie po akceptacji zamówienia`],
                    ]),
                    new Table([], [
                        ["Wpłata kaucji", brain.DepositPaymentInfo.value],
                        ["Zwrot kaucji", brain.DepositReturnInfo.value],
                    ]),
                )
            }
            else 
            {
                body.Append(
                    new Table([], [
                        ["Dostawa", DeliveryFormValueToLabel[brain.DeliveryForm.value]],
                    ]),
                )
            }

            body.Append(
                new Table([], [
                    ["Płatność", BasketPaymentValueToLabel[brain.PaymentForm.value]],
                ]),
                new Table([], [
                    ["Szkolenie", brain.TrainingInfo.value],
                ]),
                new Table([], [
                    ["Odbiorca", brain.Customer.Name.value],
                    ["Adres", brain.Customer.Address.AsString],
                    ["Kontakt", `${brain.Customer.Phone.value}, ${brain.Customer.Email.value}`],
                    ["Notatka", brain.Notes.value || "(brak)"],
                ]),
                new Center(
                    new PrimaryButton("Złóż bezpłatną rezerwację")
                        .OnClick(() =>
                        {
                            body.Clear().Append(new BasketSendingBox(_basket));
                        }),
                    new Center(returnToEditBtn).MarginTop(16),
                ).MarginTopBottom(16),
            )
        });

        this.Append(new PageFooter(_shop))
    }
}
